import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface ITicketItem {
  id: string;
  channel: number;
  status: number;
  label: string;
  ticketNumber: number;
  creationDate: number;
  link: string;
}

export interface ITicketSelector {
  id: string;
  type: MESSAGES.TICKET_SELECTOR;
  items: ITicketItem[];
  pageSize: number;
  nodeId: string;
  cta?: boolean;
  rm?: boolean;
  role?: string;
}

export const createTicketSelector = (data): ITicketSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.TICKET_SELECTOR,
  nodeId: data.nodeId,
  items: data.items,
  pageSize: data.pageSize,
  rm: Boolean(data.rm),
  cta: Boolean(data.cta),
});
